module.exports = __webpack_public_path__ + "static/img/gywm.9764a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/gywm.jpg
// module id = yKZD
// module chunks = 1 2